import { connect } from 'react-redux';
import DeliveryTimeDialog from './delivery-time-dialog';
import { selectOrderForDeliveryTimeInfo, setDeliveryTimeAction } from '../../reducers/order.reducers';

const mapStateToProps = state => ({
  open: !!state.orders.selectedOrderForDeliveryTimeInfo,
  order: state.orders.selectedOrderForDeliveryTimeInfo,
});

const mapDispatchToProps = dispatch => ({
  onClose: () => dispatch(selectOrderForDeliveryTimeInfo()),
  setDeliveryTime: (orderId, deliveryTime) => dispatch(setDeliveryTimeAction.INIT({ orderId, deliveryTime })),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryTimeDialog);
